import { useState } from "react";
import { useCounterRedemption } from "../../../Helpers/useCounterRedemption";

import Retornable from "../../../assets/icons/Retornable.svg";
import noimage from "../../../assets/icons/productoNoDisponible.svg";
import * as constant from "../../../global/const";

export const CardProductoRedemption = ({
  producto,
  limite,
  setLimite,
  numberSelected,
  setNumberSelected,
  tipoIntegracion,
  codigoSku,
  outsideCounter,
}) => {
  const [agotado, setAgotado] = useState(
    producto.agotado != null ? (producto.agotado == 1 ? true : false) : false
  );

  //const imagenUrl = constant.URL_BASE_IMAGES + "image/" + producto.codigoSku + ".png?" + Math.random();
  const [imagenUrl, setImagenUrl] = useState(
    `${constant.URL_BASE_IMAGES}image/${
      producto.codigoSku
    }.jpg?${Math.random()}`
  );
  const [
    counter,
    handleSubmitAdd,
    handleSubmitSubtract,
    handleUpdateRedemption,
  ] = useCounterRedemption(
    outsideCounter,
    producto.cantidadMin,
    tipoIntegracion
  );

  const handleChange = (counterMetodo) => {
    const filter = numberSelected.filter(
      (nb) => nb.codigoSkuPromocion == producto.codigoSku
    );

    if (filter.length > 0) {
      const aux = numberSelected.filter(
        (nb) => nb.codigoSkuPromocion != producto.codigoSku
      );

      if (aux.length == 0) {
        if (counterMetodo == 0) {
          setNumberSelected([]);
          handleUpdateRedemption(codigoSku, []);
        } else {
          filter[0].cantidad = counterMetodo;
          setNumberSelected([filter[0]]);
          handleUpdateRedemption(codigoSku, [filter[0]]);
        }
      } else {
        if (counterMetodo == 0) {
          setNumberSelected([...aux]);
          handleUpdateRedemption(codigoSku, [...aux]);
        } else {
          filter[0].cantidad = counterMetodo;

          setNumberSelected([...aux, filter[0]]);

          handleUpdateRedemption(codigoSku, [...aux, filter[0]]);
        }
      }
    } else if (counterMetodo != 0) {
      if (numberSelected.length > 0) {
        //     ...numberSelected,
        //     {
        //         codigoSku: producto.codigoSku,
        //         cantidad: counter,
        //     }
        // ]);

        setNumberSelected([
          ...numberSelected,
          {
            codigoSkuPromocion: producto.codigoSku,
            nombre: producto.nombre,
            cantidad: counterMetodo,
            numProm: producto.numProm,
          },
        ]);

        handleUpdateRedemption(codigoSku, [
          ...numberSelected,
          {
            codigoSkuPromocion: producto.codigoSku,
            nombre: producto.nombre,
            cantidad: counterMetodo,
            numProm: producto.numProm,
          },
        ]);
      } else {
        //     codigoSku: producto.codigoSku,
        //     cantidad: counter,
        // }]);

        setNumberSelected([
          {
            codigoSkuPromocion: producto.codigoSku,
            nombre: producto.nombre,
            cantidad: counterMetodo,
            numProm: producto.numProm,
          },
        ]);

        handleUpdateRedemption(codigoSku, [
          {
            codigoSkuPromocion: producto.codigoSku,
            nombre: producto.nombre,
            cantidad: counterMetodo,
            numProm: producto.numProm,
          },
        ]);
      }
    }
  };

  return (
    <div className="cardProducto">
      {agotado && (
        <div
          className="cardProducto-agotado"
          // onClick={
          //     () => {
          //         redirectToDetailProduct(producto);
          //     }
          // }
        >
          <div className="cardProducto-agotado-cajaTexto">
            <p>AGOTADO</p>
          </div>
        </div>
      )}

      <div className="cardVineta">
        {producto.vinetas.map((vineta) => {
          return (
            <div
              key={vineta.nombre}
              className="vineta"
              style={{
                backgroundColor: vineta.color + "8c",
                border: vineta.colorTexto + " 1px solid",
                color: vineta.colorTexto,
                zIndex: 1,
              }}
            >
              <div>
                <span
                  style={{
                    backgroundColor: vineta.colorTexto,
                    color: vineta.colorTexto,
                  }}
                >
                  ..
                </span>
              </div>
              <p>{vineta.texto}</p>
            </div>
          );
        })}
      </div>

      <div
        className="imagen"
        style={{
          opacity: agotado ? "0.5" : "1",
        }}
      >
        <img
          src={imagenUrl}
          alt="Not Found"
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noimage;
          }}
        />
      </div>
      <div className="nombre-producto">
        <h2>{producto.nombre}</h2>
      </div>
      <div className="presentacion-producto">
        <p>{producto.presentacionNombre}</p>
        <hr />
      </div>

      <div className="contenedor-item-box">
        <div className="item-box">
          {producto.retornable !== "" ? (
            <>
              <img className="icon-producto" src={Retornable} alt="" />
              <p>{producto.retornable}</p>
            </>
          ) : null}
        </div>
        <hr />
      </div>

      <div className={"operaciones-producto " + (agotado && "agotado")}>
        <div className={"operaciones-producto-contador"}>
          <i
            className="fa fa-minus-circle"
            aria-hidden="true"
            disabled={false}
            onClick={() => {
              handleSubmitSubtract(1, limite, setLimite);
              if (!tipoIntegracion) {
                handleChange(counter - 1 >= 0 ? counter - 1 : 0);
              } else {
                if (counter - 1 >= producto.cantidadMin)
                  handleChange(counter - 1 >= 0 ? counter - 1 : 0);
              }
            }}
          ></i>
          <p>{counter}</p>
          <i
            className="fa fa-plus-circle"
            aria-hidden="true"
            onClick={() => {
              handleChange(limite > 0 ? counter + 1 : counter);
              handleSubmitAdd(1, limite, setLimite);
            }}
          ></i>
        </div>

        {/* <button
                    type="button"
                    // onClick={() => { handleChange(counter) }}
                >Agregar</button> */}
      </div>
    </div>
  );
};
